import DefaultFlowPropertiesProvider from './DefaultFlowPropertiesProvider';

const data = {
  __init__: [ 'defaultFlowPropertiesProvider' ],
  defaultFlowPropertiesProvider: [ 'type', DefaultFlowPropertiesProvider ]
};

export default data;